export default __webpack_public_path__ + "d0f5612f257c565310d84e216fc972c2.png";